/// <amd-module name="Favorites/Panel/FavoritesPanel" />
import React = require("react");

import * as FavoritePanelResources from "Favorites/Panel/Resources";

import { Components, IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { Spinner, SpinnerSize } from "VSSUI/Spinner";

import { FavoriteItem, FavoritesListProvider } from "Favorites/Panel/FavoritesListProvider";

import { ObservableArray } from "VSS/Core/Observable";
import { FormatComponent } from "VSS/Platform/Components/Format";
import { IVssPageContext } from "VSS/Platform/Context";
import { getAssetLocation } from "VSS/Platform/Location";
import { Icon } from "VSSUI/Icon";
import { IListBoxItem, ListBox } from "VSSUI/ListBox";
import { Observer } from "VSSUI/Observer";
import { ZeroData } from "VSSUI/ZeroData";

interface IFavoritesPanelProps {
    onDismiss: () => void;
}

class FavoritesPanel extends VssComponent<IFavoritesPanelProps, {}> {
    private items: ObservableArray<IListBoxItem<FavoriteItem>>;
    private listProvider: FavoritesListProvider;
    private pageContext: IVssPageContext;

    public constructor(props: IFavoritesPanelProps, context: IVssComponentContext) {
        super(props, context);

        const providerOptions = {
            artifactScope: {
                id: "",
                name: "",
                type: "Collection"
            },
            pageContext: context.pageContext,
            onLoad: () => this.forceUpdate()
        };

        this.listProvider = new FavoritesListProvider(providerOptions);
        this.items = this.listProvider.getItems();
        this.pageContext = context.pageContext;
    }

    public render(): JSX.Element {
        if (!this.listProvider.length) {
            return <span className="no-extensions-message">{this.getNoItemsContent()}</span>;
        }

        const spinner = this.listProvider.isLoading ? (
            <div className="vss-PickList--loading">
                <Spinner size={SpinnerSize.medium} label={FavoritePanelResources.FavoritesPanel_Loading} />
            </div>
        ) : null;

        return (
            <div className="panel-favorites flex-column flex-grow scroll-auto">
                <Observer items={this.items} >
                    {(observableProps: { items: IListBoxItem<FavoriteItem>[] }) =>
                        <ListBox className="favorites-item-list" items={observableProps.items} />
                    }

                </Observer>
                {spinner}
            </div>
        );
    }

    private getNoItemsContent(): JSX.Element | string {
        const imagePath = getAssetLocation(this.pageContext, "ms.vss-favorites/favorites-panel-content/favorites-landing.svg");
        const content = this.listProvider.isLoading ? (
            ""
        ) : (
            <ZeroData
                primaryText={FavoritePanelResources.FavoritesZeroDataPrimary}
                secondaryText={this.getZeroDataSecondaryElement()}
                imagePath={imagePath}
                imageAltText={FavoritePanelResources.Favorites_ZeroFavorites_AltText}
            />
        );
        return content;
    }

    private getZeroDataSecondaryElement(): JSX.Element {
        let infoHref = "https://go.microsoft.com/fwlink/?linkid=830656";
        let infoText = FavoritePanelResources.FavoritesZeroDataInfoLinkText;

        return (
            <div>
                <FormatComponent elementType="div" className="info-text" format={FavoritePanelResources.FavoritesZeroDataSecondaryText}>
                    <Icon iconName={"FavoriteStarFill"} className={"vss-FavoriteItemPicker--starIcon"} />
                </FormatComponent>
                <br />
                <br />
                <a className="info-link" href={infoHref}>
                    {infoText}
                </a>
            </div>
        );
    }
}

Components.add("favorites-panel-content", FavoritesPanel);
